// Core types - re-export from individual files
export * from './api'
export * from './approvers'
export * from './bootstrap'
export * from './checklists'
export * from './comments'
export * from './contacts'
export * from './contracts'
export * from './grid'
export * from './notifications'
export * from './optimizations'
export * from './organizations'
export * from './products'
export * from './tasks'
export * from './updates'
export * from './users'

// Deal types
export * from './deals/approver'
export * from './deals/deals'
export * from './deals/recipients'
export * from './deals/requestor'
export * from './deals/totals'

// Organization table types
export * from './organizations_table'

// Deprecated types (kept for reference)
export * from './deprecated'

// PARENT_TYPES constant
export const PARENT_TYPES = new Set([
  'Property Management Company',
  'Ownership Group',
  'Parent Client',
  'Agency Whitelabel',
])
